var $3cf52fb2bf374b1e$exports = {};
$3cf52fb2bf374b1e$exports = {
    "Empty": `\xdcres`
};


export {$3cf52fb2bf374b1e$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
